import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { Usuario } from '../models/usuario.model';
import { FiltroLista } from '../models/filtro-lista.model';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  constructor(private http: HttpClient) {}

  async criar(body: Usuario): Promise<Usuario> {
    return await lastValueFrom(
      this.http.post<Usuario>(`${environment.apiUrl}/usuarios/criar-usuario-backoffice`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async criarUsuarioERestaurante(body: any): Promise<Usuario> {
    return await lastValueFrom(
      this.http.post<any>(`${environment.apiUrl}/usuarios/criar-usuario-e-restaurante`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async atualizar(id: string, body: Usuario): Promise<Usuario> {
    return await lastValueFrom(
      this.http.patch<Usuario>(`${environment.apiUrl}/usuarios/${id}`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async buscarTodos(): Promise<Usuario[]> {
    return await lastValueFrom(
      this.http.get<Usuario[]>(`${environment.apiUrl}/usuarios`)
    ).catch((err: any) => {
      throw err.error.message;
    });
  }
  async listar(body: FiltroLista): Promise<any[]> {
    return await lastValueFrom(
      this.http.post<any[]>(`${environment.apiUrl}/usuarios/listar`, body)
    ).catch((err: any) => {
      throw err.error.message;
    });
  }
  async validarSenha(body: any): Promise<boolean> {
    return await lastValueFrom(
      this.http.post<boolean>(`${environment.apiUrl}/usuarios/validar-senha`, body)
    ).catch((err: any) => {
      throw err.error.message;
    });
  }

  async buscarPorId(id: string): Promise<Usuario> {
    return await lastValueFrom(
      this.http.get<Usuario>(`${environment.apiUrl}/usuarios/${id}`)
    ).catch((err) => {
      throw err.error.error
    });
  }
  async buscarUsuarioComRestaurante(id: string): Promise<Usuario> {
    return await lastValueFrom(
      this.http.get<Usuario>(
        `${environment.apiUrl}/usuarios/com-restaurante/${id}`
      )
    ).catch((err) => {
      throw err.error.error
    });
  }

  async verificarUsuario(usuario: string): Promise<boolean> {
    return await lastValueFrom(
      this.http.get<boolean>(
        `${environment.apiUrl}/usuarios/verificar-usuario/${usuario}`
      )
    ).catch((err) => {
      throw err.error.error
    });
  }

  async recuperarSenha(email: string): Promise<boolean> {
    return await lastValueFrom(
      this.http.get<boolean>(
        `${environment.apiUrl}/usuarios/recuperar-senha/${email}`
      )
    ).catch((err) => {
      throw err.error.error;
    });
  }

  async enviarCodigoEmailVerificacao(body: any){
    return await lastValueFrom(
      this.http.post(`${environment.apiUrl}/usuarios/enviar-codigo-email-verificacao`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async atualizarEmailSenha(id: string, body: any){
    return await lastValueFrom(
      this.http.patch(`${environment.apiUrl}/usuarios/atualizar-email-senha/${id}`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async atualizarSenhaProvisoria(id: string, body: any){
    return await lastValueFrom(
      this.http.patch(`${environment.apiUrl}/usuarios/atualizar-senha-provisoria/${id}`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }
  async redefinirSenha(id: string, body: any){
    return await lastValueFrom(
      this.http.patch(`${environment.apiUrl}/usuarios/redefinir-senha/${id}`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async verificarEmail(email: string): Promise<boolean> {
    return await lastValueFrom(
      this.http.get<boolean>(
        `${environment.apiUrl}/usuarios/verificar-email/${email}`
      )
    ).catch((err) => {
      throw err.error.error
    });
  }

  async ativar(id: string): Promise<Usuario> {
    return await lastValueFrom(
      this.http.patch<Usuario>(
        `${environment.apiUrl}/usuarios/ativar/${id}`,
        {}
      )
    ).catch((err) => {
      throw err.error.error
    });
  }
  async desativar(id: string): Promise<Usuario> {
    return await lastValueFrom(
      this.http.patch<Usuario>(
        `${environment.apiUrl}/usuarios/desativar/${id}`,
        {}
      )
    ).catch((err) => {
      throw err.error.error
    });
  }

  async remover(id: string): Promise<Usuario> {
    return await lastValueFrom(
      this.http.delete<Usuario>(`${environment.apiUrl}/usuarios/${id}`)
    ).catch((err) => {
      throw err.error.error
    });
  }
}
